import axios from './BaseService';

const LOGS_URL = `${process.env.REACT_APP_API_URL}/logs/`;

export async function getLogs(file) {
    const safe = encodeURIComponent(String(file || '').replace(/^\//, ''));
    const response = await axios.get(`${LOGS_URL}${safe}`, {
        responseType: 'text',
        transformResponse: [(data) => data]
    });
    return response.data;
}

export async function getLogList(userId, page, pageSize = 10) {
    const params = new URLSearchParams();
    params.set('page', String(page || 1));
    params.set('pageSize', String(pageSize));
    if (userId) params.set('userId', String(userId));
    const response = await axios.get(`${LOGS_URL}?${params.toString()}`);
    return response.data;
}